import forEach from 'lodash.foreach';
import uniq from 'lodash.uniq';
import cuid from 'cuid';

export function UUID() {
  return cuid();
};

export function distance(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

export function findDeep(collection, cb) {
  if (cb(collection)) {
    return collection;
  }

  let result = undefined;

  forEach(collection, item => {
    if (cb(item)) {
      result = item;
      return false;
    }

    if (item && typeof item === 'object') {
      const tmp = findDeep(item, cb);

      if (tmp) {
        result = tmp;
        return false;
      }
    }
  });

  return result;
};

export function readFile(file, format, cb) {
  let reader = new FileReader();
  reader.onload = e => cb(e.target.result);

  switch (format) {
    case 'text':
      reader.readAsText(file);
      break;

    case 'dataURL':
      reader.readAsDataURL(file);
      break;

    default:
      reader.readAsArrayBuffer(file);
  }
};

export function formatFileSize(fileSize) {
  const KB = 1024,
        MB = 1024 * KB,
        GB = 1024 * MB;

  if (fileSize >= GB) {
    return `${(fileSize / GB).toFixed(2)} GB`;
  } else if (fileSize >= MB) {
    return `${(fileSize / MB).toFixed(2)} MB`;
  } else if (fileSize >= KB) {
    return `${(fileSize / KB).toFixed(2)} KB`;
  } else {
    return `${fileSize} Bytes`;
  }
};

export function getColorsNoInSVG(svgContent) {
  const regExp = /<path[^]+?(?:style="[^]*?(?:fill:([^]+?);)?[^]*?")?/ig,
        colors = [];

  let match;

  while (match = regExp.exec(svgContent)) {
    colors.push(match[1]);
  }

  return uniq(colors).length || 1;
};

export function setSVGColor(svgContent, color) {
  if (!svgContent) {
    return '';
  }

  return svgContent.replace(
    /<path([^]+?)(?:style="([^]*?)(?:fill:[^]+?;)?([^]*?)"\s)?/ig,
    (match, p1, p2 = '', p3 = '') => `<path${p1}style="${p2}fill:${color};${p3}" `);
}



// WEBPACK FOOTER //
// ./app/header-builder/util.js